import { ChartIcon, Grid2, Typography } from "components";
import Lottie from "lottie-react";
import { Outlet } from "react-router-dom";
import AnimationData1 from "../assets/Lottie/qBpo9KCx2d.json";

const AuthenticationLayout = () => {
  const defaultOptions1 = {
    loop: true,
    autoplay: true,
    animationData: AnimationData1,
  };

  return (
    <Grid2 container height={"100vh"} style={{ background: "var(--white)" }}>
      <Grid2
        sx={{
          display: {
            xs: "none",
            md: "flex",
          },
        }}
        size={6}
        position={"relative"}
        container
        style={{ background: `var(--primary-900)` }}
      >
        {" "}
        <div className="texture">
          <p className="one" />
          <p className="two" />
        </div>
        <Grid2
          size={12}
          display={"flex"}
          justifyContent={"center"}
          alignItems={"center"}
          flexDirection={"column"}
          position={"relative"}
        >
          <img
            loading="lazy"
            src="\Logos\GridKey_LOGO_White.png"
            alt=""
            width={200}
          />
          <Typography
            fontWeight={500}
            fontSize={18}
            color={"var(--white)"}
            mb={2}
          >
            Wealth management just got smarter
          </Typography>
          <div style={{ position: "relative", width: "50%" }}>
            <ChartIcon
              color={"var(--white)"}
              height={40}
              width={40}
              style={{
                position: "absolute",
                top: -16,
                left: -16,
                background: "#ffffff55",
                padding: 4,
                borderRadius: 6,
              }}
            />
            <Lottie
              {...defaultOptions1}
              style={{
                border: `var(--white)44 solid 1px`,
                borderRadius: "10px",
                boxShadow: `inset 0 0  10px 0 #ffffff33`,
                height: "auto",
              }}
            />
          </div>
        </Grid2>
      </Grid2>
      <Grid2
        size={{ xs: 12, md: 6 }}
        sx={{
          boxShadow: {
            xs: `0 0 18px #00000057`,
            md: "none",
          },
          border: {
            xs: `solid 1px #00000057`,
            md: "unset",
          },
          borderRadius: {
            xs: "10px",
            md: "unset",
          },
          margin: {
            xs: 4,
            md: 0,
          },
          padding: {
            xs: 4,
            md: 0,
          },
        }}
        alignSelf={"center"}
      >
        <Outlet />
      </Grid2>
    </Grid2>
  );
};

export default AuthenticationLayout;
